import FavoriteListPresenter from "../components/favorite/list/presenter/favorite-list.js";

const sectionElement = document.querySelector(`.section_favorite`);
const favoriteListComponent = new FavoriteListPresenter(sectionElement);
favoriteListComponent.init();
